
import { Component, Prop, Vue } from 'vue-property-decorator';
import { addUser, deleteUser, editUser, getUserList, getRoleList, setUserRole, batchDeleteUsers } from '@/api/users';
import { getCompanyLimit, getDepartmentList } from '@/api/company';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';

import DilogSetDepartment from './components/setDepartment.vue';
import DilogSetRole from './components/setRole.vue';
import DialogSetInvite from './components/setInvite.vue';
import DialogSetImport from './components/setImport.vue';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { getUserToken } from '@/utils/cookies';

@Component({
  name: 'StaffAll',
  components: {
    DilogSetDepartment,
    DilogSetRole,
    DialogSetInvite,
    DialogSetImport
  }
})
export default class extends Vue {
  // 页面参数定义
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private tableData = [];
  private multipleSelected = []
  private loading=false

  handleSelectionChange(val: any) {
    this.multipleSelected = val;
  }
  private isQywx=false;
  private isQyLogin:any='';
  private isServer=false;

  private limitString='';
  created() {
    if (UserModule.getCompany) {
      this.isQywx = parseInt((UserModule.getCompany as any).is_qywx) === 1;
      let vipLevel = (UserModule.getCompany as any).vip_level;
      this.isServer = vipLevel.substr(0, 1) !== '1';
    }
    let token:any = getUserToken();
    if (typeof token !== 'object') {
      token = JSON.parse(token as string);
    }
    this.isQyLogin = token.is_qywx || '';

    this.getUserList();
    this.getRoleList();
    this.getCompanyLimit();
  }

  private groupDelete() {
    if (!this.multipleSelected || this.multipleSelected.length === 0) {
      this.showErrorMsg('请选择人员');
      return;
    }
    this.$confirm('是否批量删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.delGroupUsers();
      })
      .catch(() => {});
  }
  private delGroupUsers() {
    let arr:any = [];
    this.multipleSelected.forEach((u:any) => {
      let user:any = {};
      user.id = u.id;
      user.name = u.name;
      arr.push(user);
    });

    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.users = JSON.stringify(arr);
    batchDeleteUsers(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getUserList();
      //删除更新公司权限显示
      this.getCompanyLimit();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // ---------------搜索---------------
  // 页面搜索
  private formSearch = {
    name: '',
    account: '',
    mobile: '',
    department_name: '',
    role_id: ''
  };
  // 角色数据
  private roleOptions = [];
  // 搜索
  handleSearch() {
    this.pagination.currentPage = 1
    this.multipleSelected = [];
    this.getUserList(this.formSearch);
  }
  // 清空
  handleClear() {
    this.pagination.currentPage = 1
    this.multipleSelected = [];
    this.formSearch = {
      name: '',
      account: '',
      mobile: '',
      department_name: '',
      role_id: ''
    };
    this.pagination.currentPage = 1;
    this.getUserList(this.formSearch);
  }
  // ---------------搜索---------------

  private setImportVisible = false
  private setImportType=1
  private setImportTitle='导入人员'
  importHandle() {
    this.setImportType = 1;
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.getUserList();
    this.setImportVisible = value;
  }

  private syncCommand(command: any) {
    if (command === 'commandU') {
      if (this.isQyLogin) {
        const h = this.$createElement;
        this.$confirm('提示', {
          message: h('div', [
            h('strong', '确认要开始同步？ '),
            h('p', { style: 'margin-top: 8px;font-size:12px' }, '同步将会把企业微信人员、部门及其关系同步至报修管家，服务部门不做修改。')
          ]),
          confirmButtonText: '同步',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ImportTask',
            query: { is_qywx: '1' }
          });
          window.open(routeData.href);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      } else {
        // 根据企业微信要求需通过企业微信渠道登录才能进行操作。请退出登录，在登录页点击“企业微信登录”，使用企业微信扫码登录，才能继续操作。
        const h = this.$createElement;
        this.$confirm('提示', {
          message: h('div', [
            h('strong', '请企业微信扫码登录 '),
            h('p', { style: 'margin-top: 8px;font-size:12px' }, '根据企业微信要求需通过企业微信渠道登录才能进行操作。请退出登录，在登录页点击“企业微信登录”，使用企业微信扫码登录，才能继续操作。')
          ]),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {});
      }
    } else if (command === 'commandD') {
      const h = this.$createElement;
      this.$confirm('提示', {
        message: h('div', [
          h('strong', '确认要开始同步？ '),
          h('p', { style: 'margin-top: 8px;font-size:12px' }, '同步将会把企业钉钉、部门及其关系同步至报修管家，服务部门不做修改。')
        ]),
        confirmButtonText: '同步',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$alert('这是一段内容', '钉钉同步', {
          showConfirmButton: false,
          message: h('div', { style: 'text-align: center;padding: 30px 0' }, [
            h('p', '正则载入 '),
            h('span', { 'class': { 'el-icon-loading': true }, style: '' }, '')
          ])
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    } else if (command === 'commandR') {
      this.$router.push({
        path: '/Staff/syncrecord'
      });
    }
  }

  // ----------------邀请人员--------------
  private dialogInviteVisible= false
  private dialogInviteDept = false
  inviteHandle() {
    this.dialogInviteVisible = true;
  }
  closeInvite(value:boolean) {
    this.dialogInviteVisible = value;
  }
  // ----------------邀请人员--------------
  // ----------------页面设置部门-----------------
  // 设置部门
  private setDepartmentVisible = false;
  setDeptHandle() {
    if (this.multipleSelected.length === 0) {
      this.showErrorMsg('请选择人员');
      return;
    }
    this.setDepartmentVisible = true;
  }

  departmentClose(val: boolean) {
    this.setDepartmentVisible = val;
  }
  setDeptSuccess(val: boolean) {
    this.setDepartmentVisible = val;
    this.getUserList(this.formSearch);
  }
  // ----------------页面设置部门-----------------

  // ----------------页面设置角色-----------------
  private setRoleVisible = false;
  setRoleHandle() {
    if (this.multipleSelected.length === 0) {
      this.showErrorMsg('请选择人员');
      return;
    }
    this.setRoleVisible = true;
  }
  roleClose(value: boolean) {
    this.setRoleVisible = value;
  }
  setRoleSuccess(value: boolean) {
    this.setRoleVisible = value;
    this.getUserList(this.formSearch);
    //设置角色成功更新公司权限显示
    this.getCompanyLimit();
  }
  // ----------------页面设置角色-----------------

  // -------------------添加人员----------------
  private dialogAddStaffVisible = false;
  private selectDepartmentOptions = [];
  private selectRoleOptions = [];
  // 添加人员弹框
  private formAddStaff = {
    mobile: '',
    name: '',
    password: '',
    department: '',
    role: '',
    sort: '',
    sex: '',
    email: '',
    is_vip: ''
  };
  private rules = {
    mobile: [
      { required: true, message: '请填写手机号', trigger: 'blur' },
      {
        pattern: /^1\d{10}$/,
        message: '请填写正确的手机号',
        trigger: 'blur'
      }
    ],
    name: [
      { required: true, message: '请填写2-10位由字母、中文组成的姓名', trigger: 'blur' },
      { min: 2, max: 10, message: '请填写2-10位由字母、中文组成的姓名', trigger: 'blur' },
      {
        pattern: /[\u4e00-\u9fa5a-zA-Z]/,
        message: '请填写2-10位由字母、中文组成的姓名',
        trigger: 'blur'
      }
    ],
    password: [
      { required: true, message: '请设置6-30位字母、数字、_、-组成的密码', trigger: 'blur' },
      { min: 6, max: 30, message: '请设置6-30位字母、数字、_、-组成的密码', trigger: 'blur' },
      {
        pattern: /[a-zA-Z0-9_]/,
        message: '请设置6-30位字母、数字、_、-组成的密码',
        trigger: 'blur'
      }
    ],
    email: [
      {
        pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        message: '请填写正确的邮箱',
        trigger: 'blur'
      }
    ]
  };
  addHandle() {
    this.getDepartmentList();
    this.dialogAddStaffVisible = true;
  }

  confirmHandle() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.addUser();
      } else {
        return false;
      }
    });
  }

  addUser() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      vip_level: (UserModule.company as any).vip_level,
      ...this.formAddStaff
    };
    addUser(params)
      .then((res:any) => {
        this.showSecussMsg(res.msg);
        this.formAddStaff = {
          mobile: '',
          name: '',
          password: '',
          department: '',
          role: '',
          sort: '',
          sex: '',
          email: '',
          is_vip: ''
        };
        this.dialogAddStaffVisible = false;
        this.handleClear();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  beforeClose() {
    this.dialogAddStaffVisible = false;
    this.formAddStaff = {
      mobile: '',
      name: '',
      password: '',
      department: '',
      role: '',
      sort: '',
      sex: '',
      email: '',
      is_vip: ''
    };
  }
  // -------------------添加人员----------------

  // --------------------------- 列表上的 设置角色---------------------
  private dialogSingleRoleVisible = false;
  private singleRoleData: any;
  private singleRoleOptions = [];
  private formSingleRole = {
    role: ''
  };
  singleRoleHandle(val: any) {
    // 设置角色
    this.dialogSingleRoleVisible = true;
    this.singleRoleData = val;
  }

  singleRoleHandleSave() {
    this.setUserRole(this.singleRoleData.id, this.formSingleRole.role);
  }

  dialogSingleRoleClose() {
    this.dialogSingleRoleVisible = false;
  }

  // --------------------------- 列表上的 设置角色---------------------
  // --------------------------- 列表上的 删除人员---------------------
  deleteUserHandle(val:any) {
    this.$confirm('是否把' + val.name + '从公司列表删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const params = {
        uid: val.id,
        company_id: UserModule.getCompanyId,
        company_name: UserModule.getCompanyName
      };
      deleteUser(params)
        .then((res:any) => {
          this.showSecussMsg(res.msg);
          this.handleClear();
          //删除更新公司权限显示
          this.getCompanyLimit();
        })
        .catch(err => {
          this.showErrorMsg(err.msg);
        });
    }).catch(() => {

    });
  }
  // --------------------------- 列表上的 删除人员---------------------
  // --------------------------- 列表上的 编辑人员---------------------
  private dialogEditStaffVisible = false;
  private formEditStaff = {
    account: '',
    account_id: '',
    id: '',
    uid: '',
    mobile: '',
    name: '',
    sex: '',
    sort: '',
    email: '',
    is_vip: ''
  };
  editUserHandle(val:any) {
    this.dialogEditStaffVisible = true;
    this.formEditStaff = {
      account: val.account,
      id: val.user_id_encode,
      uid: val.id,
      account_id: val.account_id,
      mobile: val.account_mobile,
      name: val.name,
      sex: val.sex,
      sort: val.sort,
      email: val.email,
      is_vip: val.is_vip
    };
  }
  editConfirmHandle() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.editorUser();
      } else {
        return false;
      }
    });
  }
  private editorUser() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      account: this.formEditStaff.account,
      uid: this.formEditStaff.uid,
      account_id: this.formEditStaff.account_id,
      mobile: this.formEditStaff.mobile,
      name: this.formEditStaff.name,
      sex: this.formEditStaff.sex,
      sort: this.formEditStaff.sort,
      email: this.formEditStaff.email,
      is_vip: this.formEditStaff.is_vip
    };
    editUser(params)
      .then((res:any) => {
        this.showSecussMsg(res.msg);
        this.dialogEditStaffVisible = false;
        this.handleClear();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  beforeEidtClose() {
    this.dialogEditStaffVisible = false;
    this.formEditStaff = {
      account: '',
      account_id: '',
      id: '',
      uid: '',
      mobile: '',
      name: '',
      sex: '',
      sort: '',
      email: '',
      is_vip: ''
    };
  }
  // --------------------------- 列表上的 编辑人员---------------------

  // 设置角色 多个userStr ，隔开
  setUserRole(userStr:string, companyRoleId:any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      company_role_id: companyRoleId,
      user_str: userStr,
      vip_level: (UserModule.company as any).vip_level
    };
    setUserRole(params)
      .then((res:any) => {
        this.showSecussMsg(res.msg);
        this.dialogSingleRoleVisible = false;
        this.getUserList(this.formSearch);
        //设置角色更新公司权限显示
        this.getCompanyLimit();
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 所有人员接口
  getUserList(val?: any) {
    this.loading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      is_user_list: 2,
      size: this.pagination.pageSize,
      page: this.pagination.currentPage,
      ...val
    };
    getUserList(params)
      .then(res => {
        this.loading = false;
        if (res.data) {
          this.tableData = res.data.list;
          this.pagination.total = res.data.count;
        } else {
          this.tableData = [];
          this.pagination.total = 0;
          this.pagination.currentPage = 1;
        }
      })
      .catch(err => {
        let msg = err.msg;
        this.tableData = [];
        this.pagination.total = 0;
        this.pagination.currentPage = 1;
      });
  }
  // 部门接口
  getDepartmentList() {
    const params = {
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      size: 9999
    };
    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          this.selectDepartmentOptions = (res as any).data.list;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }

  // 角色接口
  getRoleList() {
    const params = {
      company_id: UserModule.getCompanyId,
      size: 9999
    };
    getRoleList(params)
      .then(res => {
        if (res.data) {
          this.roleOptions = (res as any).data.list;
          this.selectRoleOptions = (res as any).data.list;
          this.singleRoleOptions = (res as any).data.list;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  // 版本人数限制
  getCompanyLimit() {
    const parameters:any = {};
    parameters.company_id = UserModule.getCompanyId;
    parameters.user_id = UserModule.getUserId;
    getCompanyLimit(parameters)
      .then(res => {
        if (res.data) {
          this.limitString = '当前版本 权限人数共' + res.data.set_role_user_number + '人（包括管理员）；已添加' + (parseInt(res.data.all_role_user_number) + 1) + '人';
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  // 页面切换
  handleCurrentChange(page: number) {
    this.pagination.currentPage = page;
    this.getUserList(this.formSearch);
  }
  // 页面数据大小切换
  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getUserList(this.formSearch);
  }

  singleDeptHandle(val: any) {
    this.setDepartmentVisible = true;
    (this.multipleSelected as any) = [val];
  }
  private getTrackShow(v:any) {
    let show = false;
    let company:any = UserModule.getCompany;
    if (company && parseInt(company.is_trajectory_record) === 1) {
      show = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.TaskTrack) && parseInt(v.engineer_type) === 1;
    }
    return show;
  }
  private taskTrack(v:any) {
    let routeData:any = this.$router.resolve({
      path: '/TaskTrack',
      query: { 'user_id': v.uid,
        'name': v.name }
    });
    window.open(routeData.href);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
